module.exports = __webpack_public_path__ + "static/media/book-heart.cdf3327b.svg";